import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import Lianxi from '../views/Lianxi.vue'
import Duanxin from '../views/Duanxin.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'Main',
    component: Main,
    meta: {
      isBack: true
    }
  },
  {
    path: '/lianxi',
    name: 'Lianxi',
    component: Lianxi,
    meta: {
      isBack: true
    }
  }
]

const router = new VueRouter({
  routes
})


export default router
